<template>
  <div class="card">
    <div class="card-content">
      <button v-on:click="closeInfo"
        class="delete" aria-label="delete"></button>
      <div class="media">
        <div class="media-left">
          <figure class="image is-48x48">
            <img v-bind:src="avatar" alt="Placeholder image">
          </figure>
        </div>
        <div class="media-content">
          <p class="title is-4">{{ title }}</p>
          <p v-if="subtitle !== ''" class="subtitle is-6">Owners: {{ subtitle }}</p>
        </div>
      </div>

      <div class="content">
        <vue-markdown>{{ body }}</vue-markdown>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown';

export default {
  name: 'Info',
  components: {
    VueMarkdown,
  },
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
      required: false,
    },
    body: {
      type: String,
      default: '',
      required: true,
    },
    avatar: {
      type: String,
      default: './img/icon-default-avatar.svg',
      required: false,
    },
  },
  methods: {
    closeInfo() {
      this.$emit('closeInfo');
    },
  },
};
</script>

<style scoped lang="scss">
  .card {
    .card-content {
      .delete {
        position: absolute;
        right: 10px;
        top: 10px;
      }
    }
  }
</style>
